import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { DIDCreditsCard } from '../../components/admin/DIDCreditsCard';
import { ArrowLeft, Video } from 'lucide-react';

export default function DIDUsage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 py-8" data-testid="did-usage-page">
      <div className="max-w-4xl mx-auto px-4">
        <Button variant="ghost" onClick={() => navigate('/admin/errors')} className="mb-4">
          <ArrowLeft className="h-4 w-4 mr-2" />Admin
        </Button>
        <h1 className="text-2xl font-bold flex items-center gap-2 mb-1"><Video className="h-6 w-6 text-emerald-600" />ALEC Video Usage</h1>
        <p className="text-gray-600 mb-6">D-ID credit balance and burn rate for the AI video interviewer</p>
        <DIDCreditsCard />
      </div>
    </div>
  );
}
